<template>
  <div class="homePage">
    <div class="section">
      <div class="crumbs">
          <router-link to="/index/gongshi" class="router-link-active">首页<i>&gt;</i></router-link>
        <router-link to="/index/homePage"  class="">招标公告<i>&gt;</i></router-link>
        <span id="bread">招标详情</span>
      </div>
    </div>

    <div class="bid-info-bar shadow section">
      <div class="biddfo-top">
        <h2 id="bidTitle">{{ title }}</h2>
        <h6 class="info-number">
          <i class="iconfont icon-shijian"></i> 公告日期：{{ bdate }}
        </h6>
        <i class="bidState bidState_ing"></i>
      </div>

      <div class="company-info-bar">
        <div class="company-info-content clearfix">
          <strong>招标类别</strong>：{{ category }}<br /><br />

          <strong>招标详情介绍</strong>：<br />

          <div v-html="content"></div>

          <div class="alert alert-warning text-center" v-if="isdeng == false" >
            报价功能仅对会员开放。如需对该招标内容进行报价，请先<router-link to="/index/register" 
              class="text-primary mx-2">注册</router-link>成为会员，<br />
            已注册会员请<router-link to="/index/login"  class="text-primary mx-2" >登录</router-link>后进行报价。
          </div>
          <router-link to="/index/login"  class="boajia" v-if="isdeng == false" >立即报价</router-link>

          <!--如果登录了就显示下面的-->
          <div class="wodess" v-if="isdeng == true">
            <div class="woflex">
              <div class="wof1">我的报价：</div>
              <div class="wof2">
                <input
                  placeholder="请输入您的报价（单位：元）"
                  name="mobile2" 
                  class="hmyinput" v-model="toutitle"
                />
              </div>
            </div>

            <div class="woflex">
              <div class="wof1">报价详情：</div>
              <div class="wof2">
                <textarea
                  rows="4"
                  class="hmyinput"
                  placeholder="请输入您的报价详情（选填）" v-model="toucontent"
                ></textarea>
              </div>
            </div>

           
          </div>
          <a  class="boajia"
            style="margin-top: 0"  v-if="isdeng == true" @click="open()">立即报价</a>
          <!--如果登录了就显示end-->
        </div>
      </div>

      <div class="bid-info-foot clearfix">
        <i id="reportTime" class="fr">截止日期：{{ edate }}</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  components: {},
  data() {
    return {
      title: '',
      content:'',
      bdate: '',
      edate:'',
      category: '',
      isdeng: '',
      article_id:'',
      toutitle:'',
      toucontent:''    
    };
  },
  created() {},
  mounted() {
    this.getreqZhaobiaoInfo(this.$route.query.id);
    this.article_id = this.$route.query.id;
    let loToke = localStorage.getItem('tb_token');
    if (loToke) {
      this.isdeng = true;
    } else {      
      this.isdeng = false;
    }
  },
  methods: {
    async getreqZhaobiaoInfo(id) {
      let res = await this.req.reqZhaobiaoInfo({
        id,
      });
      console.log(res);
      if (res.status == 200) {
        let articleinfo = res.data.detail;
        this.title = articleinfo.title;
        this.content = articleinfo.content;
        this.bdate = articleinfo.bdate;
        this.edate = articleinfo.edate;
        this.category = articleinfo.category.name;
      } else {
        this.$message.error(res.message);
      }
    },
      // 投标
    async reqtoubiao(){
				var that = this;
				var form = {
					title:this.toutitle,
					content:this.toucontent,
				};
				let res = await this.req.reqtoubiao({
					article_id:this.article_id,
					form
				});
				if(res.status == 200){
					this.$message.success(res.message);
					setTimeout(function(){
						that.$router.push("/index/mybaojia");
					},1000)
				}else{
					this.$message.error(res.message);
				}
			},
         //投标提示
         open() {  
            let that = this;
            if (!this.toutitle.trim()) {
               this.$message.error('报价不能为空');
               return
            }
            // 有可能价格后面有数字
            // const numRegex = /^-?\d+(\.\d+)?$/
            //    if (!numRegex.test(this.toutitle)) {
            //       this.$message.error('请输入有效数字');
            //       return
            //    }
            this.$confirm('此操作将对此标书进行报价, 是否继续?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               that.reqtoubiao()
    
            }).catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               });          
            });
         }



  },
};
</script>

<style lang="less" scoped>
</style>
